import { render, staticRenderFns } from "./editor_field.vue?vue&type=template&id=4f4dd556&lang=pug&"
import script from "./editor_field.vue?vue&type=script&lang=js&"
export * from "./editor_field.vue?vue&type=script&lang=js&"
import style0 from "./editor_field.vue?vue&type=style&index=0&id=4f4dd556&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports